/**
 * Adds a new URL param to a URL and returns it.
 *
 * This supports "#" URLs. It adds params before the "#".
 */
export const addUrlParam = (originalUrl: string, paramName: string, paramValue: string) => {
    const parts = originalUrl.split('#');
    const operator = parts[0].includes('?') ? '&' : '?';
    return parts[0] + operator + paramName + '=' + encodeURIComponent(paramValue)
        + (parts.length === 2 ? ('#' + parts[1]) : '');
};

export const getInputUrl = (linkType: string, hostname: string, selectedRank: string, customInputUrl: string) => {
    const protocal = location.protocol;
    switch (linkType) {
        case 'joinReliv':
            return protocal + '//' + hostname + '/join-reliv';
        case 'customerForm':
            return protocal + '//' + hostname + '/signup-form/customer';
        case 'preferredCustomerForm':
            return protocal + '//' + hostname + '/signup-form/preferred-customer';
        case 'distributorForm':
            return protocal + '//' + hostname + '/signup-form/distributor'
                + (selectedRank ? '?rank=' + selectedRank : '');
        case 'custom':
            return customInputUrl;
    }
};

export const getOutputUrl = (inputUrl: string, sponsorRcn: string, couponCode: string) => {
    let outputUrl = addUrlParam(inputUrl, 'sponsorRcn', sponsorRcn);
    if (couponCode.length !== 0) {
        outputUrl = addUrlParam(outputUrl, 'couponCode', couponCode);
    }
    return outputUrl;
};